/* eslint-disable */
import Vue from 'vue';
import { directive as onClickOutside } from 'vue-on-click-outside';
import Vuelidate from 'vuelidate';
import Datetime from 'vue-datetime';
import CKEditor from "@ckeditor/ckeditor5-vue";

import store from '@/store/store';
import router from '@/router';
import App from '@/app/App';
import IsJsonString from '@/mixins/CheckJsonString';
import "@/libs/css/ckeditor.css";
import MiddlewareService from "@/MiddlewareService.js";
import { UrlLogger, LogSeverity } from '@/helpers/Constants';

Vue.use(Vuelidate);
Vue.use(Datetime);
Vue.directive('on-click-outside', onClickOutside);

Vue.config.productionTip = true;

Vue.use(CKEditor);

new Vue({
  el: '#app',
  mixins: [MiddlewareService, IsJsonString],
  data() {
    return {
      clientData: {}
    };
  },
  router,
  store,
  methods: {
    sendReport(msg, stack, severity) {
      try {
        this.requestApi(`${UrlLogger}/Logs`, 'post', {
          message: JSON.stringify({ href: location.href, msg: msg, stack: stack }),
          severity: LogSeverity.frontEnd | severity
        }, false, false);
      } catch (ex) {
        console.log(ex);
      }
      console.log('error: ', msg);
    }
  },
  created() {
    if ((process.env.MODE === 'prod' || process.env.MODE === 'stage') && location.host.indexOf('localhost') === -1) {
      window.onerror = async (msg, src, linenum, colnum, error) => {
        let stack = '';
        let message = '';
        if (msg instanceof Error) {
          stack = msg.stack || '';
          message = msg.message || msg.toString();
        } else if (error && error.stack) {
          stack = error.stack;
          message = msg;
        } else {
          message = msg && msg.toString ? msg.toString() : String(msg);
        }
        stack += ` line: ${linenum} col: ${colnum} in ${src}`;
        this.sendReport(message, stack, LogSeverity.critical);
      };
      Vue.config.errorHandler = async (err, vm, info) => {
        const message = (err && err.message ? err.message : String(err)) + ` | Info: ${info}`;
        const stack = vm.$options.name + '\n' + (err && err.stack ? err.stack : '');
        this.sendReport(message, stack, LogSeverity.critical);
      };
      Vue.config.warnHandler = async(msg, vm, info) => {
        this.sendReport(msg + ` | Info: ${info}`, vm.$options.name, LogSeverity.warning);
      };
    }
  },
  render: h => h(App),
});
